/////////////////////////////////////
/*   FILE FOR ALL NEW JS METHODS   */
/////////////////////////////////////
/////////////////////////////////////
//        UTILITY METHODS          //
/////////////////////////////////////
//
//
//
const _document = $(document);
const RANDOM_ID = () => {
  return (Math.random() + 1).toString(36).slice(2,10);
}


//  PRODUCT.COMPLETED TEMPLATE

const COMPLETED_PIECES = () => {
  if(typeof components !== 'undefined'){
    let variants = [];
    let price = $('.product__price span');
    let quantity = $('.select-popout__toggle span');
    let qty_minus = $('#product-panel .quantity .minus');
    let qty_change = $('.select-popout__toggle span');
    let qty_plus = $('#product-panel .quantity .plus');
    let add_to_cart = $('button[name="add"]');
    let adding = false;
    let modal = $('#engrave_popup');
    let modal_html = $('#engrave_popup .e-options-inner');
    let modal_close = $('#engrave_popup .close_btn');

    let find_selected = (index) => {

      let option1 = $('.variant_radios input[name="option1-' + index + '"]:checked');
      let option2 = $('.variant_radios input[name="option2-' + index + '"]:checked');
      let option3 = $('.variant_radios input[name="option3-' + index + '"]:checked');

      for(let element of components['component' + (index + 1)].variants){

        if(element.option1 != null && (cleanString(option1.val()) != cleanString(element.option1))){continue;}
        if(element.option2 != null && (cleanString(option2.val()) != cleanString(element.option2))){continue;}
        if(element.option3 != null && (cleanString(option3.val()) != cleanString(element.option3))){continue;}
        return element;

      };

      return false;

    }

    let update_selected = (index) => {
      let option1 = $('.variant_radios input[name="option1-' + index + '"]:checked');
      let option2 = $('.variant_radios input[name="option2-' + index + '"]:checked');
      let option3 = $('.variant_radios input[name="option3-' + index + '"]:checked');

      if(option1.length > -1 & $("[data-option1-" + index + "] .selected_variant").length > -1){
        $("[data-option1-" + index + "] .selected_variant").html(option1.siblings("label").html());
      }
      if(option2.length > -1 & $("[data-option2-" + index + "] .selected_variant").length > -1){
        $("[data-option2-" + index + "] .selected_variant").html(option2.siblings("label").html());
      }
      if(option3.length > -1 & $("[data-option3-" + index + "] .selected_variant").length > -1){
        $("[data-option3-" + index + "] .selected_variant").html(option3.siblings("label").html());
      }
    }


    /********************************
     *
     *   SELECTED 1,2,& 3 NEED CORRECT VALUES
     *
    ********************************/

    let disable_unavailable = (variant, comp, index) => {
      let selected1 = cleanString(variant.option1);
      let selected2 = cleanString(variant.option2);
      let selected3 = cleanString(variant.option3);
      let opts1 = [];
      let opts2 = [];
      let opts3 = [];

      if(selected1 != null){opts1 = window[comp].options[0].values;}
      if(selected2 != null){opts2 = window[comp].options[1].values;}
      if(selected3 != null){opts3 = window[comp].options[2].values;}

      $(`.component_container[data-component="${comp}"] .variant_radios input[type="radio"]`).removeAttr('disabled');

      if(opts1.length > 0 && opts2.length > 0){
        for(let val of opts1){
          let found = false;
          for(let element of window[comp].product.variants){
            if(cleanString(element.option1) == cleanString(val)){
              if(opts3.length > 0){
                if(cleanString(element.option2) == selected2 && cleanString(element.option3) == selected3){
                  found = true;
                }
              }else{
                if(cleanString(element.option2) == selected2){
                  found = true;
                }
              }
            }
          }
          if(!found){
            $(`.component_container[data-component="${comp}"] .variants_container input[name="option1-${index}"][value="${cleanString(val)}"]`).attr('disabled', true);
          }
        }

        for(let val of opts2){
          let found = false;
          for(let element of window[comp].product.variants){
            if(cleanString(element.option2) == cleanString(val)){
              if(opts3.length > 0){
                if(cleanString(element.option1) == selected1 && cleanString(element.option3) == selected3){
                  found = true;
                }
              }else{
                if(cleanString(element.option1) == selected1){
                  found = true;
                }
              }
            }
          }
          if(!found){
            $(`.component_container[data-component="${comp}"] .variants_container input[name="option2-${index}"][value="${cleanString(val)}"]`).attr('disabled', true);
          }
        }

        if(opts3.length > 0){

          for(let val of opts3){
            let found = false;
            for(let element of window[comp].product.variants){
              if(cleanString(element.option3) == cleanString(val)){
                if(cleanString(element.option1) == selected1 && cleanString(element.option2) == selected2){
                  found = true;
                }
              }
            }
            if(!found){
              $(`.component_container[data-component="${comp}"] .variants_container input[name="option3-${index}"][value="${cleanString(val)}"]`).attr('disabled', true);
            }
          }


        }

      }


    }

    let cleanString = (s) => {
      if (s == null){return s;}
      return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    let current_state = () => {
      let total_price = 0;
      let upon_request = false;
      variants = [];

      $(".component_container[data-component]").each(function(index){
        let variant = find_selected(index);
        let current_price = variant.price;
        if(typeof current_price === "string" || current_price instanceof String){
          current_price = parseInt(parseFloat(current_price) * 100);
        }
        disable_unavailable(variant, $(this).data('component'), index);
        total_price = total_price + current_price;
        if(current_price == 0){
          upon_request = true;
        }
        variants.push({
          id: variant.id,
          comp: $(this).data('component')
        });
      });

      $(".component_container[data-component]").each(function(){
        let comp = $(this).data('component');

        //$(`.cta-btn[data-component="${comp}"]`).html("ENGRAVE +");

        if(window[comp].addCost && (window[comp].embossing || window[comp].engravable)){
          if(window[comp].sides > 0){
            for(let [index, side] of window[comp].sidesArray.entries()){
              if(side != ''){
                if(!window[comp].byHandSelected){total_price = total_price + window[comp].machineCost;}
                $(`.cta-btn[data-component="${comp}"]`).html("EDIT +");
                break;
              }
            }
          }
        }

        if(window[comp].pieces > 0){
          for(let [index, piece] of window[comp].pieceArray.entries()){
            if(piece != ''){
              if(!window[comp].byHandSelected && window[comp].addCost){total_price = total_price + window[comp].machineCost;}
              $(`.cta-btn[data-component="${comp}"]`).html("EDIT +");
              break;
            }
          }
        }

        if(window[comp].singleValue.length > 0){
          if(window[comp].addCost){
            total_price = total_price + window[comp].machineCost;
          }
          $(`.cta-btn[data-component="${comp}"]`).html("EDIT +");
        }

      });

      total_price = total_price * parseInt(quantity.html());
      let formatted_price = Intl.NumberFormat(currency_setting, {
          style: 'currency',
          currency: current_currency,
          minimumFractionDigits: 2, // Ensure two decimal places
      }).format((parseInt(total_price) / 100).toFixed(2));

      if(upon_request){
        $('body').addClass('upon_request');
        $('#request_product').text(`Requesting Pricing for [product title], [variants]`);
				$('#request_hidden_product').val(`Requesting Pricing for [product title], [variants]`);
      }else{
        $('body').removeClass('upon_request');
      }

      if(window.location.href.indexOf('contact_posted=true') > -1){
        $('body').addClass('upon_request');
        $('#request_submitted').show();
      }
      
      price.html(formatted_price);

    }

    let update_engravable = () => {
      let comp = modal.data('comp');

      if(window[comp].sides > 0){
        for(let [index, side] of window[comp].sidesArray.entries()){
          window[comp].sidesArray[index] = $(`[name="SIDE${index}"]`).val();
        }

      }

      if(window[comp].pieces > 0){
        for(let [index, piece] of window[comp].pieceArray.entries()){
          window[comp].pieceArray[index] = $(`[name="PIECE${index}"]`).val();
        }

      }

      if(window[comp].singleName.length > 0){
        window[comp].singleValue = $(`[name="${window[comp].singleName}"]`).val();
      }

      return true
    }

    let propertiesData = (comp) => {

      let propData = {"Completed": product_title};

      return propData;

    }


    $('.variant_radios input[type=radio]').change(() => {current_state();});
    $('.variant_nav').click(function(){
      if($(this).hasClass('variant_next')){
        $(this).siblings('.variant_radios').animate({scrollLeft: ($(this).siblings('.variant_radios').scrollLeft() + 100)}, 200);
      }else{
        $(this).siblings('.variant_radios').animate({scrollLeft: ($(this).siblings('.variant_radios').scrollLeft() - 100)}, 200);
      }
    });

    // QUANTITY HANDLER 

    // Get the initial quantity value
    var initialQuantity = $('.select-popout__toggle span[data-popout-toggle-text]').text();
    var previousQuantity = initialQuantity;
  
    // Function to be executed when the quantity changes
    function handleQuantityChange() {
      // Get the current quantity value
      var currentQuantity = $('.select-popout__toggle span[data-popout-toggle-text]').text();
  
      // Compare the current quantity with the previous quantity
      if (currentQuantity !== previousQuantity) {
        // Quantity has changed, execute your function here
        current_state();
  
        // Update the previous quantity
        previousQuantity = currentQuantity;
      }
    }

    // Listen for changes in the quantity span's content
    $('.select-popout__toggle span[data-popout-toggle-text]').on('DOMSubtreeModified', handleQuantityChange);

    // END QUANTITY HANDLER 

     add_to_cart.click((e) => {
      e.preventDefault();
      if(!adding){

        adding = true;
        $(this).find('.btn__loader').text("Adding...");

        let payload = {items: []};

        

        for (var variant of variants) {
          payload.items.push({
            quantity: parseInt(quantity.html()),
            id: variant.id,
            "properties" : propertiesData(variant.comp)
          });
        }
        $.ajax({
          type: 'POST',
          url: window.Shopify.routes.root + 'cart/add.js',
          data: payload,
          dataType: 'json',
          complete: function() {
              _document.trigger('updateCart');
              setTimeout(function(){
                $('.icon-bag').click();
                adding = false;
                add_to_cart.find('.btn__text').text("Add to Bag");
                $('.variant_radios input[type=radio]').eq(0).prop('checked', true);
                current_state();
              }, 0);
            }

        });

      }
    });

    let hide_overflow = () => {
            let eligible = $('.variant_buttons[data-inline-buttons]:not(.short_list_closed)');
            $.each(eligible, function(){
              let height = $(this).height();
              let buttons = $(this).find('.variant_buttons');
              if(height > 45){
                let more_count = 0;
                let first_y = $(this).find('.variant_radios label').first().position().top;
                $(this).css('height', '68px').css('padding-right', '70px').css('max-height', '68px');
                $.each($(this).find('.variant_radios label'), function(index, element){

                  if($(element).position().top > first_y){more_count++;}
                })
                $(this).append('<button class="more_variants" data-more="' + more_count + '" data-closed=true>See ' + more_count + ' more +</button>');
                $(this).find('.more_variants').click(function(){
                  toggle_overflow(this);
                });
              }
            });
    }

    let toggle_overflow = (target) => {


            if($(target).attr('data-closed') == 'true' || $(target).attr('data-closed') == true){
              $.each($(".more_variants[data-closed='false']"), function(index, element){
                $(element).parent().css('height', '').css('max-height', '68px');
                $(element).text("See " + $(element).attr('data-more') + " more +").attr('data-closed', 'true');
              });
              $(target).attr('data-closed', 'false');
              $(target).parent().css('height', '').css('max-height', '200px');
              $(target).text("Hide -");
            }else{
              $.each($(".more_variants[data-closed='false']"), function(index, element){
                $(element).parent().css('height', '').css('max-height', '68px');
                $(element).text("See " + $(element).attr('data-more') + " more +").attr('data-closed', 'true');
              });
            }

    }

    let  = (target) => {
            if($(target).attr('data-closed') == 'true' || $(target).attr('data-closed') == true){
              $.each($(".more_variants[data-closed='false']"), function(index, element){
                $(element).parent().css('height', '').css('max-height', '68px');
                $(element).text("See " + $(element).attr('data-more') + " more +").attr('data-closed', 'true');
              });
              $(target).attr('data-closed', 'false');
              $(target).parent().css('height', '').css('max-height', '200px');
              $(target).text("Hide -");
            }else{
              $.each($(".more_variants[data-closed='false']"), function(index, element){
                $(element).parent().css('height', '').css('max-height', '68px');
                $(element).text("See " + $(element).attr('data-more') + " more +").attr('data-closed', 'true');
              });
            }

    }

    $.each($(".component_container .variant_radios[data-variant-slider]"), function(i, element){
      let selected = $(element).find('input[type="radio"]:checked');
       if(selected.position().left > $(element).width()){
          $(element).animate({scrollLeft: $(element).scrollLeft() + selected.position().left - $(element).width() + 100}, 200);
        }
    });



    hide_overflow();
    current_state();



  }
}

//  END PRODUCT.COMPLETED TEMPLATE
//
//


/////////////////////////////////////
/*  INVOKE PAGE SPECIFIC METHODS   */
/////////////////////////////////////
var html = $('html'); // Define html as the HTML element
switch(html.attr('id')) {
    
  case 'product-completed':
      COMPLETED_PIECES();
    break;

}
